import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { memo } from 'react';

const defaultAllowedTags = ["br", "a", "b", "i", "span", "p", "em", "strong", "sub", "sup"];
const SafeHTML = memo(({ html, allowedTags = defaultAllowedTags }) => {
  const cleanHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: ["href", "target", "rel"],
    ADD_ATTR: ["target"]
  });
  return parse(cleanHtml);
});
SafeHTML.displayName = "SafeHTML";

export { SafeHTML };
